export const ViewMode = {
  GATE: 'Gate',
  RESULTS_PAGE: 'Gate Result Page',
  ACCOUNT_LEVEL_GATE: 'Account Level Gate',
  ACCOUNT_LEVEL_RESULTS_PAGE: 'Account Level Gate Result Page',
  STOREFRONT: 'Storefront',
  STOREFRONT_BNG: 'Storefront BNG',
  WHOIS: 'who is',
  BASE44: 'Base44',
  FUNNEL_GATE: 'Funnel',
  FUNNEL_RESULTS_PAGE: 'Funnel Result Page'
};
//# sourceMappingURL=types.js.map